import { render, staticRenderFns } from "./SharingInherited.vue?vue&type=template&id=cedf3238&scoped=true"
import script from "./SharingInherited.vue?vue&type=script&lang=js"
export * from "./SharingInherited.vue?vue&type=script&lang=js"
import style0 from "./SharingInherited.vue?vue&type=style&index=0&id=cedf3238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedf3238",
  null
  
)

export default component.exports